<template>
  <div v-if="loading" class="bg-white mar-top pad-ver">
    <van-skeleton title :row="10"></van-skeleton>
  </div>
  <div v-else>
    <div class="mar-top custom-steps room-control" v-if="colList.length">
      <van-cell-group :title="roomTitle">
        <van-cell :title="roomDoc.roomNum"></van-cell>
      </van-cell-group>
      <van-cell-group v-if="mDoc" title="当前会议">
        <van-cell :title="mDoc.subject"></van-cell>
      </van-cell-group>

      <van-cell-group>
        <van-cell v-for="ele in colList" :key="ele.key"
                  :title="ele.title" :icon="ele.icon"
                  @click="handleOperate(ele.key)" is-link></van-cell>
      </van-cell-group>
    </div>
    <div v-else>
      <empty-notice :desc="expired? '二维码已失效' : '暂无内容'"></empty-notice>
    </div>

    <submit-repair :show="showRepairPopup"
                   :meeting-room-id="rid"
                   @handle-cancel="showRepairPopup=$event"></submit-repair>
  </div>
</template>

<script>
  import {meeting, meetingRoom} from "../../../../server";
  import {checkShowPermit, checkTsExpired} from "../../../../tools/utils"
  import routerMeta from "../../router/routerMeta";
  import SubmitRepair from "./SubmitRepair"

  const operateInfo = {
    deviceCtrl: {
      key: "deviceCtrl",
      icon: "aim",
      title: "设备控制"
    },
    serviceCall: {
      key: "serviceCall",
      icon: "description",
      title: "会中服务"
    },
    deviceRepair: {
      key: "deviceRepair",
      icon: "setting-o",
      title: "设备报修"
    },
  };

  export default {
    components: {
      SubmitRepair
    },
    data() {
      return {
        rid: "",
        loading: true,
        roomDoc: null,
        mDoc: null,
        expired: false,
        showRepairPopup: false,
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      showPermits() {
        const permissionList = this.$store.state.permissionList || [];
        return {
          deviceCtrl: checkShowPermit(permissionList, this.permitsMap.deviceCtrl),
          serviceCall: checkShowPermit(permissionList, this.permitsMap.serviceCall),
          deviceRepair: checkShowPermit(permissionList, this.permitsMap.deviceRepair),
        }
      },
      colList() {
        // console.log(this.roomDoc);
        // console.log(this.mDoc);
        const list = [];
        if (this.roomDoc) {
          this.showPermits.deviceCtrl && list.push(operateInfo.deviceCtrl);
          this.roomDoc.isServiceSupport && this.mDoc && this.showPermits.serviceCall && list.push(operateInfo.serviceCall);
          this.showPermits.deviceRepair && list.push(operateInfo.deviceRepair);
        }
        return list
      }
    },
    created() {
      if (checkTsExpired.call(this)) {
        this.loading = false;
        return
      }
      this.rid = this.$route.params.rid;
      this.initRoomDoc();
      this.getMeeting()
    },
    methods: {
      initRoomDoc() {
        UILoader.load();
        // 查询会议 => 过滤会议室信息
        meetingRoom.queryList(this, {
          queryFilter: {
            selfCursor: this.rid,
          },
          queryAll: true
        }).then(({searchRoom: data = {}}) => {
          UILoader.unload();
          this.loading = false;
          const [edge] = (data.roomEdges || []);
          if (edge && edge.cursor === this.rid && edge.room) {
            this.roomDoc = edge.room;
          } else {
            vtToast(`${this.roomTitle}不存在`)
          }
        }).catch(err => {
          UILoader.unload();
          this.loading = false;
          // console.log(err);
          vtToast(err.message)
        });
      },
      getMeeting() {
        meeting.queryList(this, {
          queryFilter: {
            meetingRoomId: this.rid,
            meetingStatus: ["MEETING"]
          }
        }).then(({searchMeeting: data = {}}) => {
          const [firstEdge] = data.meetingEdges || [];
          if (firstEdge) {
            this.mDoc = {...firstEdge.meeting, mid: firstEdge.cursor}
          }
        }).catch(err => {
        })
      },
      // 操作跳转路由 设备控制、呼叫服务、设备报修
      handleOperate(key) {
        switch (key) {
          case operateInfo.deviceCtrl.key:
            this.$router.push({
              name: routerMeta.deviceCtrl.name,
              params: {rid: this.rid},
            });
            break;
          case operateInfo.serviceCall.key:
            this.mDoc && this.$router.push({
              name: routerMeta.callService.name,
              params: {mid: this.mDoc.mid},
            });
            break;
          case operateInfo.deviceRepair.key:
            this.showRepairPopup = true;
            break;
          default:
        }
      }
    }
  }
</script>

<style lang="less">
  .room-control {
    .van-cell {
      font-size: 15px !important;
    }
  }
</style>
